import { render, staticRenderFns } from "./onePager-footer.vue?vue&type=template&id=2b3f6bec&scoped=true"
import script from "./onePager-footer.vue?vue&type=script&lang=js"
export * from "./onePager-footer.vue?vue&type=script&lang=js"
import style1 from "./onePager-footer.vue?vue&type=style&index=1&id=2b3f6bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3f6bec",
  null
  
)

export default component.exports